<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import HelloWorld from './components/HomePage.vue'
export default {
  name: 'App',
  
}
</script>

<style>



@import url("https://use.typekit.net/yey6vrm.css");

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
.full-height {
  min-height: 100vh;
}
</style>
